module.exports = __webpack_public_path__ + "img/1474415008.65e9f982.jpg";